import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-billing',
  template: `
  <router-outlet></router-outlet>
  `,
  styles: []
})
export class BillingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/system/billing/billing.component.ts